"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImg = void 0;
const styles_1 = require("@mui/material/styles");
exports.StyledImg = (0, styles_1.styled)("img")(({ contain }) => ({
    width: "100%",
    height: "100%",
    display: "block",
    objectFit: contain ? "contain" : "cover",
    objectPosition: "center",
    position: "relative"
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21lZGlhL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBOEM7QUFNakMsUUFBQSxTQUFTLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQWlCLENBQUMsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN2RSxLQUFLLEVBQUUsTUFBTTtJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsT0FBTyxFQUFFLE9BQU87SUFDaEIsU0FBUyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxPQUFPO0lBQ3hDLGNBQWMsRUFBRSxRQUFRO0lBQ3hCLFFBQVEsRUFBRSxVQUFVO0NBQ3JCLENBQUMsQ0FBQyxDQUFDIn0=